import { observer } from 'mobx-react';
import { FC, ReactElement, memo, useMemo } from 'react';
import { mealItemEditModalStore } from '../../store/mealItemEditModalStore';
import integrationsStore from '~/mobx/integrationStore';
import { TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import LazyProductsPicker from '~/view/components/Controls/Pickers/LazyProductsPicker/LazyProductsPicker';
import { transformToPickerOption } from '~/view/components/Controls/Pickers/Picker/helpers';
import { IPickerOption, PickerPosition, PickerUnavailableType } from '~/view/components/Controls/Pickers/Picker/types';
import IntegrationManager from '~/view/components/IntegrationManager/IntegrationManager';
import { localeStore } from '~/mobx/localesStore';

export const MealItemEditModalFormItemsPicker: FC = memo(
  observer((): ReactElement => {
    const { comboMealChangeItemInItemChoice } = integrationsStore.posRestrictions || {};

    const selectedOptions = useMemo((): IPickerOption[] => {
      return mealItemEditModalStore.item ? [transformToPickerOption(mealItemEditModalStore.item)] : [];
    }, [mealItemEditModalStore.item]);

    return (
      <div className="d-flex flex-column">
        <IntegrationManager
          setting={comboMealChangeItemInItemChoice}
          wrapperClassName="mt-2"
          tooltipOptions={{ position: TOOLTIP_POSITION.PORTAL, wrapperClassName: 'full-width' }}
          withTooltip
        >
          <LazyProductsPicker
            searchable
            selectedOptions={selectedOptions}
            onSelect={mealItemEditModalStore.onSelectItem}
            returnFullData={mealItemEditModalStore.onSetFullItemsList}
            position={PickerPosition.PORTAL}
            markUnavailable
            unavailableType={PickerUnavailableType.PRODUCT_FOR_MEAL}
            disableUnavailable
            className="full-width"
          />
        </IntegrationManager>

        {mealItemEditModalStore.showOpenMealItemMdfExclModalButton && (
          <button onClick={mealItemEditModalStore.onOpenMealItemMdfExclModal} className="meal-edit-modal__btn-open-mdf-excl-modal mt-2">
            {localeStore.t('cm_config_page_show_modifiers_and_exclusions')}
          </button>
        )}
      </div>
    );
  })
);
